import React, { memo } from "react";
import { formats } from "investira.sdk";
import { HighchartsReact } from "investira.react.charts";

const TipoAtivoChart = memo((props) => {
  const { data = [] } = props;

  const processData = (data) => {
    const xData = Object.values(data);
    const xTotal = xData.reduce(
      (sum, item) => sum + item.financeiro_diferenca,
      0,
    );

    const xThreshold = xTotal * 0.01; // 1% do total
    const xMainData = {};

    let xOthersSumFinanceiro = 0;
    let xOthersSumQuantidade = 0;
    let xOthersSumAtivos = 0;

    Object.entries(data).forEach(([xKey, xItem]) => {
      if (xItem.financeiro_diferenca >= xThreshold) {
        xMainData[xKey] = xItem;
      } else {
        xOthersSumFinanceiro += xItem.financeiro_diferenca;
        xOthersSumQuantidade += xItem.quantidade_diferenca;
        xOthersSumAtivos += xItem.quantidade_ativos;
      }
    });

    if (xOthersSumFinanceiro > 0) {
      xMainData.OUTROS = {
        financeiro_diferenca: xOthersSumFinanceiro,
        quantidade_diferenca: xOthersSumQuantidade,
        quantidade_ativos: xOthersSumAtivos,
      };
    }

    return xMainData;
  };

  const reduceData = (pData = [], pGroupBy = "mercado", pNameKey = "setor") => {
    let xGrouped = pData.reduce((xAcc, xItem) => {
      const xKey = xItem[pGroupBy];

      if (!xAcc[xKey]) {
        xAcc[xKey] = {
          financeiro_diferenca: 0,
          quantidade_diferenca: 0,
          quantidade_ativos: 0,
        };
      }

      xAcc[xKey].ativo_tipo = xItem.ativo_tipo;
      xAcc[xKey].financeiro_diferenca += xItem.financeiro_diferenca;
      xAcc[xKey].quantidade_diferenca += xItem.quantidade_diferenca;
      xAcc[xKey].quantidade_ativos += xItem.quantidade_ativos;

      return xAcc;
    }, {});

    xGrouped = processData(xGrouped);

    const xResult = Object.entries(xGrouped).map(([xKey, xValue]) => {
      const xKeys = Object.keys(xGrouped).filter((key) => key !== "OUTROS");

      if (
        xValue.quantidade_diferenca === 0 &&
        xValue.financeiro_diferenca === 0
      ) {
        return null;
      }

      if (xKey === "OUTROS") {
        return {
          name: "Outros",
          y: xValue.financeiro_diferenca,
          dataLabels: {
            color: "#FFFFFF",
          },
          // drilldown: xKey,
          metadata: {
            quantidade_ativos: xValue.quantidade_ativos,
            financeiro_diferenca: formats.formatNumber(
              xValue.financeiro_diferenca,
              2,
              true,
              true,
            ),
            quantidade_diferenca: formats.formatNumber(
              xValue.quantidade_diferenca,
              6,
              true,
            ),
            ativos: pData
              .filter((xItem) => !xKeys.includes(xItem[pGroupBy]))
              .map((xItem) => xItem),
          },
        };
      }

      return {
        name: xValue[pNameKey],
        y: xValue.financeiro_diferenca,
        // drilldown: xKey,
        dataLabels: {
          color: "#FFFFFF",
        },
        metadata: {
          quantidade_ativos: xValue.quantidade_ativos,
          financeiro_diferenca: formats.formatNumber(
            xValue.financeiro_diferenca,
            2,
            true,
            true,
          ),
          quantidade_diferenca: formats.formatNumber(
            xValue.quantidade_diferenca,
            6,
            true,
          ),
          ativos: pData
            .filter((xItem) => xItem[pGroupBy] === xKey)
            .map((xItem) => xItem),
        },
      };
    });
    return xResult;
  };

  const xData = reduceData(data, "ativo_tipo_id", "ativo_tipo");

  const xOptions = {
    chart: {
      type: "pie",
      height: "320px",
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: "50%",
        borderColor: "#2e2e46",
        borderWidth: 2,
        shadow: false,
        center: ["50%", "50%"],
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            return `
                          <span style="color: #FFFFFF; text-decoration: none;">${this.point.name}</span><br/>
                          <span style="color: #FFFFFF; text-decoration: none;">
                           ${this.point.metadata.financeiro_diferenca}
                          </span><br/>
                          <span style="color: #FFFFFF; text-decoration: none;">
                           ${this.point.metadata.quantidade_diferenca}
                          </span>`;
          },
          style: {
            color: "#FFFFFF",
            textOutline: "none",
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000,
      },
      pointFormat: `Financeiro Diferença: <b>{point.metadata.financeiro_diferenca}</b><br>Quantidade Diferença: <b>{point.metadata.quantidade_diferenca}</b>`,
    },
    series: [
      {
        name: "Tipo de Ativo",
        colorByPoint: true,
        data: xData,
        dataLabels: {
          color: "#ffffff",
          enabled: true,
          style: {
            fontSize: "11px", // Reduz o tamanho da fonte
            outline: "none",
          },
        },
      },
    ],
  };

  return <HighchartsReact options={xOptions} drilldown />;
});

export default TipoAtivoChart;
